export default {
  prepareSequenceImages: Array(31)
    .fill('')
    .map((v, i) =>
      require(`../../../Box_sequences/img_sequence_monitorbox/monitorbox${
        i < 10 ? `0${i}` : i
      }.jpg`)
    ),
  designSliderImage: require('../../../product drawing/monitors/22Inch_Coin B.png'),
  designImageList: [
    {
      number: 1,
      side: 'BOTTOM',
      image: require('../../../parts/coinbankB/Coin BankB01.png'),
    },
    {
      number: 2,
      side: 'TOP',
      image: require('../../../parts/coinbankB/Coin BankB02.png'),
    },
  ],
  cutOutPartsImage: require('../../../parts/coinbankB/Coin BankB03.png'),
  cutOutPartsFoldImage: require('../../../parts/coinbankB/Coin BankB04.png'),
  assembleSequenceImages: Array(45)
    .fill('')
    .map((v, i) =>
      require(`../../../sequences/11_coin_bankB_sequence/coinbankB${
        i < 10 ? `0${i}` : i
      }.jpg`)
    ),

  completeImage: require('../../../complete/CoinBankSet.jpg'),
  completeImagePc: require('../../../complete/CoinBankSet.jpg'),
};
